/* eslint-disable import/no-cycle */
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import { injectContainerIfNeeded } from '../../cms/CmsScreen';
import Banner from '../../headers/blocks/Banner';
import BannerAds from '../../home/blocks/BannerAds';
import CloudTvBlock from '../../home/blocks/CloudTvBlock/CloudTvBlock';
import CloudTvCommentsBlock from '../../home/blocks/CloudTvBlock/components/CloudTvCommentsBlock';
import CountdownBlock from '../../home/blocks/CountdownBlock';
import FlocklerBlock from '../../home/blocks/FlocklerBlock';
import ImageWithIcons from '../../home/blocks/ImageWithIcons';
import ImageWithZones from '../../home/blocks/ImageWithZones';
import NextLiveCountdownBlock from '../../home/blocks/NextLiveCountdownBlock';
import SocialWallWidgetBlock from '../../home/blocks/SocialWallWidgetBlock';
import TiltedMenuBlock from '../../home/blocks/TiltedMenuBlock';
import WorkshopsWithRegistrationBlock from '../../home/blocks/WorkshopsWithRegistrationBlock';
import UpcomingSessions from '../../home/components/UpcomingSessions';
import UserSchedule from '../../profile/blocks/UserSchedule';
import UserProfileNetworkingBlock from '../../profile/components/UserProfileNetworkingBlock';
import SocialWallBlock from '../../social-wall/blocks/SocialWallBlock';
import Blocks from '../Blocks';
import ContactsBlock from '../ContactsBlock';
import GridLayout from '../GridLayout';
import HeaderBlock from '../HeaderBlock';
import NotificationRequestButton from '../NotificationRequestButton/NotificationRequestButton';
import RestrictOpeningTimesBlock from '../RestrictOpeningTimesBlock';
import AchievementsBlock from './AchievementsBlock';
import ActionsBlock from './ActionsBlock';
import { Action } from './ActionsBlock/ActionsBlock';
import AddressBlock from './AddressBlock';
import BlockWrapper from './BlockWrapper.tsx';
import BrowserCheckBlock from './BrowserCheckBlock';
import CMSWorkshopLiveBlock from './CMSWorkshopLiveBlock';
import CTATileBlock from './CTATileBlock';
import CTATilesBlock from './CTATilesBlock';
import CarouselBlock from './CarouselBlock';
import CategoryWorkshopsBlock from './CategoryWorkshopsBlock';
import ClickableMapBlock from './ClickableMapBlock';
import CmsModalBlock from './CmsModal';
import ContactBlock from './ContactBlock';
import DataVoteBlock from './DataVoteBlock';
import FaqBlock from './FaqBlock';
import FilesBlock from './FilesBlock';
import FlightBlock from './FlightBlock/FlightBlock';
import { GamificationCodeBlock } from './GamificationCodeBlock/GamificationCodeBlock';
import HomeImageBlock from './HomeImageBlock/HomeImageBlock';
import HtmlBlock from './HtmlBlock';
import IconGridBlock from './IconGridBlock';
import IframeBlock from './IframeBlock';
import ImageBlock from './ImageBlock';
import { InfoBlock } from './InfoBlock/InfoBlock';
import { InteractionsBlock } from './InteractionsBlock/InteractionsBlock';
import ItemGridBlock from './ItemGridBlock';
import LogosBlock from './LogosBlock';
import PhotoGalleryBlock from './PhotoGalleryBlock';
import PlanBlock from './PlanBlock';
import ProgramBlock from './ProgramBlock';
import QrcodeBlock from './QrcodeBlock';
import { RegistrationListBlock } from './RegistrationListBlock/RegistrationListBlock';
import ReplayBlock from './ReplayBlock';
import RoomingBlock from './RoomingBlock/RoomingBlock';
import RoommateBlock from './RoommateBlock';
import SearchBlock from './SearchBlock';
import SidebarMenuBlock from './SidebarMenuBlock';
import SocialWallFeedWidget from './SocialWallFeedWidget/SocialWallWidget';
import SpeakersBlock from './SpeakersBlock';
import TemplateBlock from './TemplateBlock';
import { TypologyBlock } from './TypologyBlock/TypologyBlock';
import UserPreferencesModalBlock from './UserPreferencesModalBlock';
import UserProfileModalBlock from './UserProfileModalBlock';
import { UsersBlock } from './UsersBlock/UsersBlock';
import VideoBlock from './VideoBlock';
import VideosBlock from './VideosBlock';
import { WorkshopAgendaBlock } from './WorkshopAgendaBlock/WorkshopAgendaBlock';
import WorkshopFeedbackPopupBlock from './WorkshopFeedbackPopupBlock';
import WorkshopFilesBlock from './WorkshopFilesBlock';
import WorkshopVideoBlock from './WorkshopVideoBlock';
import WorkshopsBlock from './WorkshopsBlock/WorkshopsBlock';
import WorkshopsMapBlock from './WorkshopsMapBlock';

export const CmsBlocks = ({ blocks, injectContainer = false }) => (
  <Blocks
    blocks={blocks}
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    blockComponents={cmsFields}
    blockWrapper={injectContainer ? injectContainerIfNeeded : undefined}
  />
);

const RowBlock = ({ id, blocks, className, style, _id, injectContainer, stretched, stackable }) => (
  <Grid stackable={stackable} id={id}>
    <Grid.Row
      className={cx('cms-page--block', 'column--row', _id, className)}
      style={style}
      stretched={stretched}
    >
      <CmsBlocks blocks={blocks} injectContainer={injectContainer} />
    </Grid.Row>
  </Grid>
);

RowBlock.defaultProps = {
  blocks: [],
  className: '',
  id: undefined,
  injectContainer: false,
  stretched: true,
  style: {},
  stackable: false,
};

RowBlock.propTypes = {
  _id: PropTypes.string.isRequired,
  blocks: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  id: PropTypes.string,
  injectContainer: PropTypes.bool,
  style: PropTypes.object,
  stretched: PropTypes.bool,
  stackable: PropTypes.bool,
};

const ColumnBlock = ({ id, _id, width, blocks, className, injectContainer }) => (
  <Grid.Column
    id={id}
    className={cx('cms-page--block', `column--block`, _id, className)}
    width={width}
    style={{ flex: width ? undefined : 1 }}
  >
    <CmsBlocks blocks={blocks} injectContainer={injectContainer} />
  </Grid.Column>
);

export const cmsFields = {
  action: Action,
  actions: ActionsBlock,
  address: AddressBlock,
  agenda: UserSchedule,
  workshopAgenda: WorkshopAgendaBlock,
  banner: Banner,
  bannerAds: BannerAds,
  blockContainer: BlockWrapper,
  browserCheck: BrowserCheckBlock,
  carousel: CarouselBlock,
  categoryWorkshops: CategoryWorkshopsBlock,
  clickableMap: ClickableMapBlock,
  contacts: ContactsBlock,
  cloudTv: CloudTvBlock,
  cloudTvComments: CloudTvCommentsBlock,
  cmsModal: CmsModalBlock,
  column: ColumnBlock,
  contact: ContactBlock,
  countdown: CountdownBlock,
  ctaTile: CTATileBlock,
  ctaTiles: CTATilesBlock,
  dataVotes: DataVoteBlock,
  flight: FlightBlock,
  flockler: FlocklerBlock,
  faq: FaqBlock,
  files: FilesBlock,
  gallery: PhotoGalleryBlock,
  gamificationCode: GamificationCodeBlock,
  grid: GridLayout,
  header: HeaderBlock,
  html: HtmlBlock,
  roommate: RoommateBlock,
  homeImage: HomeImageBlock,
  iconGrid: IconGridBlock,
  iframe: IframeBlock,
  image: ImageBlock,
  imageWithIcons: ImageWithIcons,
  imageWithZones: ImageWithZones,
  info: InfoBlock,
  interactions: InteractionsBlock,
  itemGrid: ItemGridBlock,
  logos: LogosBlock,
  nextLiveCountdown: NextLiveCountdownBlock,
  networking: UserProfileNetworkingBlock,
  notificationRequestButton: NotificationRequestButton,
  qrcode: QrcodeBlock,
  registrationList: RegistrationListBlock,
  plan: PlanBlock,
  program: ProgramBlock,
  replay: ReplayBlock,
  restrictOpeningTimes: RestrictOpeningTimesBlock,
  rooming: RoomingBlock,
  row: RowBlock,
  search: SearchBlock,
  sidebarMenuBlock: SidebarMenuBlock,
  socialWall: SocialWallBlock,
  socialWallWidget: SocialWallWidgetBlock,
  socialWallFeedWidget: SocialWallFeedWidget,
  speakers: SpeakersBlock,
  achievements: AchievementsBlock,
  template: TemplateBlock,
  tiltedMenu: TiltedMenuBlock,
  upcomingSessions: UpcomingSessions,
  userProfileModal: UserProfileModalBlock,
  userPreferencesModal: UserPreferencesModalBlock,
  users: UsersBlock,
  video: VideoBlock,
  videos: VideosBlock,
  workshopFiless: WorkshopFilesBlock,
  workshopFeedbackPopup: WorkshopFeedbackPopupBlock,
  workshopLive: CMSWorkshopLiveBlock,
  workshopsMap: WorkshopsMapBlock,
  workshopVideo: WorkshopVideoBlock,
  workshopsWithRegistration: WorkshopsWithRegistrationBlock,
  workshops: WorkshopsBlock,
  typology: TypologyBlock,
};
